module.exports = __webpack_public_path__ + "static/chips-and-salsa-d636539e42c394f965e46dfaaebc0b87.jpg";